@if (!instructionsHTML) {
    <epd-spinner size="large" [isVisible]="true" [fullscreen]="false"></epd-spinner>
} @else {
    <div class="instructions-container" [innerHTML]="instructionsHTML"></div>
}
